import React, {Component} from "react";

import FileDownload from "js-file-download";
import {Modal, Panel, PanelGroup, Table} from "react-bootstrap";

import {EquipmentPage} from "./EquipmentPage";
import {MaterialPage} from "./MaterialPage";
import api from "../../api";
import Auth from "../../Auth";
import Menu from "../../Menu";
import {properties} from "../../properties";

class AddImageModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			progress: "",
			activeKey: "1",
			old: [],
			order: [],
			actives: [],
		};
	}

	componentDidMount() {
		this.get_ids();
	}

	setAsActive(i) {
		const data = {
			_id: this.state.order[i],
		};

		api.post(`/image/active`, data, Auth.headers())
			.then(response => this.props.onClose())
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	deleteImage(i) {
		const data = {
			_id: this.state.order[i],
		};

		api.post(`/image/delete`, data, Auth.headers())
			.then(response => {
				alert("The image was successfully deleted");
				this.get_ids();
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	getImgById(id) {
		const config = Auth.headers();
		config["responseType"] = "blob";

		const data = {
			_id: id,
		};

		api.post(`/image/id`, data, config)
			.then(response => {
				const matrixBlob = new Blob([response.data], {type: "image/jpg"});
				const fileReader = new FileReader();
				const header = response.headers["content-disposition"];
				const filename = /filename=(.*)/.exec(header)[1].replace(/"/g, "");
				fileReader.readAsDataURL(matrixBlob);
				fileReader.onload = () => {
					const result = fileReader.result;
					this.setState(state => ({
						old: state.old.concat(<img style={{maxHeight: 150}} alt={"img-" + id} src={result} />),
						order: state.order.concat(id),
						actives: state.actives.concat(filename === "True" ? "active" : ""),
					}));
				};
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	get_ids() {
		const data = {
			material: this.props.item.material,
			type: "img",
			operator: this.props.item.operator,
			part_number: this.props.item.part_number,
		};

		api.post(`/images`, data, Auth.headers())
			.then(response => {
				this.setState({ids: response.data, old: [], order: [], actives: []});
				for (const id in response.data) {
					this.getImgById(response.data[id]);
				}
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	downloadImage(i) {
		const config = Auth.headers();
		config["responseType"] = "blob";

		const item = this.props.item;

		const data = {
			_id: this.state.order[i],
		};

		api.post(`/image/id`, data, config)
			.then(response => {
				const filename = `${item.operator}-${item.material}-${item.part_number}.jpg`;
				FileDownload(response.data, filename, filename);
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	handleSelect(activeKey) {
		this.setState({activeKey});
	}

	uploadFile(e) {
		const formData = new FormData();
		const input = e.target;
		if (input.files.length > 0) {
			for (const file of input.files) {
				formData.append(file.name, file);
			}
			const config = Auth.headers();
			config["Content-Type"] = "multipart/form-data";
			config["onUploadProgress"] = progressEvent => {
				this.setState({
					progress: progressEvent.loaded < progressEvent.total ? "Uploading files..." : "Processing files...",
				});
			};
			api.post(
				`/upload/image?operator=${this.props.item.operator}&material=${this.props.item.material}&part_number=${this.props.item.part_number}`,
				formData,
				config,
			)
				.then(resp => {
					if (resp.data.message) {
						alert(resp.data.message);
					} else {
						alert("Your files were successfully uploaded!");
					}
					this.props.onClose();
				})
				.catch(error => {
					if (error.response.status === 401) {
						alert("Your session expired! Please login again!");
						Auth.logout();
						this.props.history.replace(Auth.redirectToLogin());
					} else {
						alert(error.response.data.message);
					}
				})
				.finally(() => {
					input.value = "";
					this.setState({progress: ""});
				});
		}
	}

	render() {
		const rows = this.state.old.map((v, i) => (
			<tr
				style={{
					backgroundColor: this.state.actives[i] === "active" ? "#ccffcc" : "",
				}}>
				<td>{v}</td>
				<td>
					<p>
						<a onClick={() => this.setAsActive(i)}>Set as active</a>
					</p>
					<p>
						<a onClick={() => this.downloadImage(i)}>Download</a>
					</p>
					<p>
						<a onClick={() => this.deleteImage(i)}>Delete</a>
					</p>
				</td>
			</tr>
		));

		return (
			<Modal show={this.props.show} onHide={() => this.props.onClose()} onClose={() => this.props.onClose()}>
				<Modal.Header bsStyle="primary" closeButton>
					<Modal.Title>Image Editor</Modal.Title>
				</Modal.Header>

				<PanelGroup
					accordion
					style={{padding: 5}}
					id="accordion-controlled-example"
					activeKey={this.state.activeKey}
					onSelect={activeKey => this.handleSelect(activeKey)}>
					<Panel eventKey="1">
						<Panel.Heading>
							<Panel.Title toggle>Upload image by file</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<input
								type="file"
								onChange={e => this.uploadFile(e)}
								multiple
								disabled={this.state.progress !== ""}
							/>
						</Panel.Body>
						<Panel eventKey="2">
							{rows.length > 0 && (
								<Panel eventKey="3">
									<Panel.Heading>
										<Panel.Title toggle>Select previously uploaded image</Panel.Title>
									</Panel.Heading>
									<Panel.Body collapsible>
										<Table bordered condensed hover className="text-center">
											<thead>
												<tr>
													<th className="text-center">Image</th>
													<th className="text-center">Action</th>
												</tr>
											</thead>
											<tbody>{rows}</tbody>
										</Table>
									</Panel.Body>
								</Panel>
							)}
						</Panel>
					</Panel>
				</PanelGroup>
			</Modal>
		);
	}
}

export class FullPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			item: {
				type: "",
			},
			images: [],
			documentsList: [],
		};
	}

	componentDidMount() {
		const operator = new URLSearchParams(window.location.search).get("operator");
		const material = new URLSearchParams(window.location.search).get("material");

		let url = properties.apiUrl;
		if (sessionStorage.getItem("item_url") && sessionStorage.getItem("item_url") !== null) {
			url = sessionStorage.getItem("item_url");
		} else if (localStorage.getItem("item_url") && localStorage.getItem("item_url") !== null) {
			url = localStorage.getItem("item_url");
			sessionStorage.setItem("item_url", url);
		}

		api.post(`/item/type-info?operator=${encodeURIComponent(operator)}&material=${material}`, {url})
			.then(json => {
				this.setState({
					item: {
						operator,
						material,
						part_number: json.data.part_number,
						type: json.data.type || "material",
					},
				});
			})
			.catch(error => {
				this.setState({
					item: {
						operator,
						material,
						part_number: "",
						type: "material",
					},
				});
			});
		this.getDocumentsList(operator, material);
	}

	getDocumentsList = (operator, material) => {
		api.post(`/documents/get`, {operator, material})
			.then(json => {
				this.setState({
					documentsList: json.data,
				});
			})
			.catch(error => console.log(error));
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.item !== this.state.item) {
			this.get_ids();
			this.getDocumentsList(this.state.item.operator, this.state.item.material);
		}
	}

	onModalClose = () => {
		this.setState({showModal: false, image: ""});
		this.get_ids();
	};

	getImgById(id) {
		const config = Auth.headers();
		config["responseType"] = "blob";

		const data = {
			_id: id,
		};

		api.post(`/image/id`, data, config)
			.then(response => {
				const matrixBlob = new Blob([response.data], {type: "image/jpg"});
				const fileReader = new FileReader();
				const header = response.headers["content-disposition"];
				const filename = /filename=(.*)/.exec(header)[1].replace(/"/g, "");
				fileReader.readAsDataURL(matrixBlob);
				fileReader.onload = () => {
					const result = fileReader.result;
					this.setState(state => ({
						images: state.images.concat({
							image: result,
							active: filename === "True" ? 1 : 0,
						}),
					}));
				};
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					console.log(error);
				}
			});
	}

	get_ids() {
		const data = {
			material: this.state.item.material,
			type: "img",
			operator: this.state.item.operator,
			part_number: this.state.item.part_number || "",
		};

		api.post(`/images`, data)
			.then(response => {
				this.setState({
					ids: response.data,
					images: [],
					order: [],
					actives: [],
				});
				for (const id in response.data) {
					this.getImgById(response.data[id]);
				}
			})
			.catch(error => {
				if (error.response.status === 401) {
					alert("Your session expired! Please login again!");
					Auth.logout();
					this.props.history.replace(Auth.redirectToLogin());
				} else {
					this.setState({ids: [], images: [], order: [], actives: []});
					console.log(error);
				}
			});
	}

	updateItem = part_number => {
		if (part_number !== this.state.item.part_number) {
			this.setState({
				item: {
					...this.state.item,
					part_number: part_number,
				},
			});
		}
	};

	render() {
		return (
			<div>
				<Menu history={this.props.history} />
				{this.state.item.type === "material" && (
					<MaterialPage
						documentsList={this.state.documentsList}
						image={this.state.image}
						onItemUpdate={this.updateItem}
						show={true}
						getDocumentsList={this.getDocumentsList}
						images={this.state.images}
						openImageModal={() => this.setState({showModal: true})}
					/>
				)}

				{this.state.item.type === "equipment" && (
					<EquipmentPage
						onItemUpdate={this.updateItem}
						getDocumentsList={this.getDocumentsList}
						documentsList={this.state.documentsList}
						image={this.state.image}
						show={true}
						images={this.state.images}
						openImageModal={() => this.setState({showModal: true})}
					/>
				)}

				{this.state.showModal && (
					<AddImageModal show={this.state.showModal} onClose={this.onModalClose} item={this.state.item} />
				)}
			</div>
		);
	}
}
